import { createReducer } from '@reduxjs/toolkit';

import getWarehouseExist, { clearWarehouseExist } from '../../thunks/general/getWarehouseExist';

const initialState = {
  loading: false,
  error: null,
  data: [],
};

const getWarehouseExistReducer = createReducer(initialState, {
  [getWarehouseExist.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getWarehouseExist.fulfilled]: (state, { payload: { data } }) => ({
    ...state,
    data,
    loading: false,
  }),
  [clearWarehouseExist]: () => initialState,
  [getWarehouseExist.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default getWarehouseExistReducer;
